<template>
  <!-- 轮播图组件，使用场景 bananer图 -->
  <div class="carousel-wrapper">
    <el-carousel
      ref="carousel"
      v-bind="$attrs"
      :height="mobileHeight"
      :class="{ 'is-horizontal': isHorizontal }"
      @change="handleCarouselChange"
      :style="{ borderRadius, boxShadow: cardStyle?.boxShadow }"
    >
      <el-carousel-item
        v-for="(item, index) in deepList"
        class="rid-img"
        :key="index"
        :label="isHorizontal ? item.indicatorName : ''"
        :style="[
          item.url ? { backgroundImage: `url(${item.url})` } : '',
          { backgroundColor: item.backgroundColor }
        ]"
      >
        <div
          class="content mobile-carousel-content"
          :style="{
            ...transfCssUtil({ padding: item.padding, textAlign: item.textAlign, justifyContent: item.justifyContent }),
            cursor: item.link ? 'pointer' : '',
            
          }"
          :class="{ flexLayout: !item.padding }"
          @click.prevent="openUrl(item.link)"
        >
        
          <!-- 标签文字 -->
          <div v-if="item.icons && item.icons?.show" @click.prevent.stop="handleClickItem(index, 5, $event)">
            <img :src="item.icons.url" :style="transfCssUtil(item.icons)">
          </div>
          <!-- 标签文字 -->
          <div
            v-if="item.tagTitle?.show"
            class="tagTitle"
            :style="transfCssUtil(item.tagTitle)"
            @click.prevent.stop="handleClickItem(index, 10, $event)"
          >
            <TextEdit
              change-key="imgList"
              :text.sync="item.tagTitle.desc"
              :mode="textEdit"
              :sendData="deepList"
              v-on="$listeners"
            />
          </div>
          <!-- 主标题 -->
          <div
            v-if="item.mainTitle.show"
            class="mainTitle"
            :style="transfCssUtil(item.mainTitle)"
            @click.prevent.stop="handleClickItem(index, 1, $event)"
          >
            <TextEdit
              change-key="imgList"
              :text.sync="item.mainTitle.desc"
              :mode="textEdit"
              :sendData="deepList"
              v-on="$listeners"
            />
          </div>
          <!-- 副标题 -->
          <div
            v-if="item.subTitle.show"
            class="subTitle mobile-sub-title carousel-mobile-sub-title"
            :style="transfCssUtil(item.subTitle)"
            @click.prevent.stop="handleClickItem(index, 2, $event)"
          >
            <!-- {{ item.subTitle.desc }} -->
            <TextEdit
              change-key="imgList"
              :text.sync="item.subTitle.desc"
              :mode="textEdit"
              :sendData="deepList"
              v-on="$listeners"
            />
          </div>
          <!-- 按钮组 -->
          <div
            class="btns"
            v-if="item.btns.length"
          >
            <div
              class="btn-item mobile-btn-item"
              v-for="(btn, b_index) of item.btns"
              :key="b_index"
              @click.prevent.stop="mode ? openUrl(btn.url) : handleClickItem(index, 3, $event)"
              :style="transfCssUtil(btn.btnCss)"
            >
              <span
                :style="btn.fontCss"
                class="mobile-btn-title"
              >{{ btn.label }}</span>
            </div>
          </div>
          <!-- 数据卡片 -->
          <div v-if="item.list && item.list.length" class="data-card-wrapper"  @click.prevent.stop="handleClickItem(index, 9, $event)">
            <div v-for="itemEl in item.list" class="data-card-item">
              <div class="data-item-maintitle" :style="transfCssUtil(itemEl.mainTitle)">{{ itemEl.mainTitle.desc }}</div>
              <div class="data-item-subtitle" :style="transfCssUtil(itemEl.subTitle)">{{ itemEl.subTitle.desc }}</div>
            </div>
          </div>
          <div v-if="showCounter" class="item-counter" :style="transfCssUtil(counterStyle)">{{index + 1}} / {{deepList.length}} </div>
          
        </div>
        <video
          v-if="item.videoUrl"
          class="video-wrapper"
          :src="item.videoUrl"
          :controls="false"
          loop
          muted
          ref="video-wrapper"
          :id="`video_${index}`"
        ></video>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { transfCssUtil, arrToPx } from '../../utils/index'
import mixin from '../../utils/mixin'
import TextEdit from '../common/TextEdit.vue'
export default {
  name: 'advanceCarousel',
  mixins: [mixin],
  props: {
    cardStyle: {
      type: Object
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    counterStyle: {
      type: Object
    }
  },
  data () {
    return {
      transfCssUtil (conf) {
        const gradientColor = conf.gradientColor
        if (gradientColor) {
          return {
            ...transfCssUtil(conf),
            backgroundImage: gradientColor,
            color: '#0000',
            'background-clip': 'text',
            '-webkit-background-clip': 'text',
          }
        } else {
          return transfCssUtil(conf)
        }
      },
      screenWidth: document.documentElement.clientWidth,
      mobileHeight: this.$attrs.height
      // borderRadius: arrToPx(this.cardStyle?.borderRadius)
      // deepList: this.$attrs.imgList
    }
  },
  computed: {
    borderRadius () {
      const { borderRadius } = this.cardStyle || {}
      return arrToPx(borderRadius || [0, 0, 0, 0])
    },
    deepList () {
      return this.$attrs.imgList
    },
    isHorizontal () {
      return this.$attrs.direction === 'horizontal'
    },
    // 指示器自动播放时间
    intervalTime () {
      let time = 0
      if (this.$attrs.autoplay) {
        time = this.$attrs.interval / 1000
      }
      return time
    }
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    this.handleCarouselChange(0)
  },
  watch: {
    '$attrs.height' (val) {
      this.mobileHeight = val
    },
    screenWidth: {
      handler (val) {
        let relHeight = parseInt(this.$attrs.height)
        if (val < 768) {
          this.mobileHeight = parseInt(relHeight * 0.7) + 'px'
        } else {
          this.mobileHeight = relHeight + 'px'
        }
      },
      immediate: true
    }
  },
  methods: {
    handleCarouselChange (val) {
      const targetItem = this.deepList[val]
      if (targetItem.videoUrl) {
        const video = this.$refs[`video-wrapper`]
        video.forEach(item => {
          item.pause()
        })
        const currentVideo = document.getElementById(`video_${val}`)
        currentVideo.play()
      }
    }
  },
  components: {
    TextEdit
  }
}
</script>
<style lang="stylus" scoped>
.carousel-wrapper {
  .rid-img {
    background-position: center;
    // background-size auto 100%
    background-size: cover;
    background-repeat: no-repeat;
  }

  .is-horizontal {
    >>>.el-carousel__indicators--labels {
      padding-bottom: 25px;
    }

    >>>.el-carousel__indicator {
      .el-carousel__button {
        background-color: transparent;

        span {
          font-size: 14px;
          color: #2F4773;
          line-height: 20px;
          font-weight: 400;
        }
      }

      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background-color: rgba(47, 71, 115, 0.1);
        transform-origin: left;
        margin-top: 7px;
      }
    }

    >>>.el-carousel__indicator.is-active {
      .el-carousel__button span {
        color: #155EFF;
      }

      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background-color: #155EFF;
        animation: progress v-bind('`${intervalTime}s`') linear 0s 1;
        transform-origin: left;
        margin-top: 7px;
      }

      &:hover::after {
        animation: none;
      }
    }
  }

  .content {
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 40px;
    height: 100%;
    box-sizing: border-box;

    .tagTitle {
      font-size: 28px;
      color: #000;
      line-height: 48px;
      font-weight: 500;
      max-width: 680px;
      word-break: break-all;
    }

    .mainTitle {
      font-size: 32px;
      color: #000;
      line-height: 44px;
      font-weight: 600;
      max-width: 680px;
      word-break: break-all;
    }

    .subTitle {
      white-space: pre-line;
      font-size: 16px;
      color: #646a73;
      font-weight: 500;
      line-height: 26px;
      max-width: 680px;
      word-break: break-all;
    }

    .btn-item {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      cursor: pointer;
    }
    .item-counter {
      margin-top: 20px;
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
    }
    .data-card-wrapper {
      display flex
      justify-content space-around
      flex-wrap wrap
      .data-item-maintitle {
        font-weight: 500;
        font-size: 48px;
        line-height: 72px;
        text-align: center;
      }
      .data-item-subtitle {
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
      }
    }
  }

  .flexLayout {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 0;
    z-index: 4;
    transform: translateX(-50%);
  }
}
.video-wrapper
  width: 100%
  height: 100%
  object-fit: cover;
  position: absolute
  top: 0
  left: 0
  z-index: 3
@media screen and (max-width: 768px) {
  .carousel-wrapper .mobile-carousel-content {
    align-items: center;
    // margin: 0 36px;
  }
}

@keyframes progress {
  0% {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
}
</style>